import Vue from 'vue'
import './element-variables.scss'
import {
  Button,
  Form,
  FormItem,
  Input,
  InputNumber,
  Select,
  Cascader,
  Option,
  Loading,
  Link,
  MessageBox,
  Message,
  Container,
  Header,
  Aside,
  Avatar,
  Badge,
  Menu,
  MenuItem,
  Main,
  Table,
  TableColumn,
  Pagination,
  Notification,
  Submenu,
  Tabs,
  TabPane,
  DatePicker,
  Upload,
  Popover,
  Tag,
  Radio,
  RadioGroup,
  Row,
  Col,
  Image,
  Rate,
  Dialog,
  Checkbox,
  CheckboxGroup,
  Collapse,
  CollapseItem,
  Steps,
  Step,
  Dropdown,
  DropdownItem,
  DropdownMenu
} from 'element-ui'

Vue.use(Aside)
Vue.use(Avatar)
Vue.use(Badge)
Vue.use(Button)
Vue.use(Cascader)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Col)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Container)
Vue.use(DatePicker)
Vue.use(Dialog)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Header)
Vue.use(Image)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Link)
Vue.use(Loading.directive)
Vue.use(Main)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Option)
Vue.use(Pagination)
Vue.use(Popover)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Rate)
Vue.use(Row)
Vue.use(Select)
Vue.use(Step)
Vue.use(Steps)
Vue.use(Submenu)
Vue.use(TabPane)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Tabs)
Vue.use(Tag)
Vue.use(Upload)
Vue.use(Dropdown)
Vue.use(DropdownItem)
Vue.use(DropdownMenu)

Vue.prototype.$loading = Loading.service
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$notify = Notification
Vue.prototype.$message = Message
